module.exports = __webpack_public_path__ + "static/media/klasa_6.185966a5.svg";